import React, { useState, useEffect } from 'react'
import './FindStore.css'
import { StyledContainer } from '../../LandingPageStyles'
import Autocomplete from '@mui/material/Autocomplete'
import {
    Box,
    Card,
    CardContent,
    Typography,
    CardActions,
    Button,
    CardHeader,
    TextField,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import {  createStyles, makeStyles } from '@material-ui/core/styles'
import { API_KEY, API_SECRET, makeHttpRequest } from 'utils/api_utils'
const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& > *': {
                margin: theme.spacing(3),
            },
        },
    })
)

export const FindStore = () => {
    const { t } = useTranslation()
    const classes = useStyles()
    const [storeData, setstoreData] = useState([])
    const [storeLocationName, setstoreLocationName] = useState([ ])
    var SamsungImage = '/assets/images/find-store.png'

    useEffect(() => {
        getAllCustomerReviews()
    }, [])
    const getAllCustomerReviews = () => {
        fetch(`${process.env.REACT_APP_API_URL}get_stores`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Key: API_KEY,
                Secret: API_SECRET,
                country: localStorage.getItem('country') || 'ke',
            },
        })
            .then((response) => response.json())
            .then(({ success, stores }) => {
                if (success) {
                    setstoreData(stores)
                    let tempData = []
                    stores.map((data) => {
                        if (data.active === true) {
                            tempData.push({ label: data.name, value: data.name })
                        }
                    })
                    console.log('tempDatatempData',tempData);
                    setstoreLocationName(tempData)
                }
            })
            .catch((error) => {
                console.error('Error:', error)
            })
    }
    return (
        <>
            {storeData && storeData.length != 0 ? (
                <>
                    <StyledContainer>
                        <div
                            className="labelss"
                            style={{ paddingBottom: '26px' }}
                        >
                            <div className="text-wrappers">
                                <span className="badilistorelabel">
                                {t('description.find_badili_store')}
                                </span>
                                <span
                                    style={{
                                        marginLeft: '10px',
                                        cssFloat: 'right',
                                        color: '#58cab9',
                                        fontFamily:
                                            '"Open Sans-Bold", Helvetica',
                                        fontSize: '18px',
                                        fontWeight: 700,
                                        left: '0',
                                        letterSpacing: '0.36px',
                                        lineHeight: '32.4px',
                                        height: '32px',
                                        width: '73px',cursor: "pointer" 
                                    }}
                                >
                                    {t('description.view_all_tz')}
                                </span>
                            </div>
                        </div>{' '}
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={storeLocationName}
                            //getOptionLabel={(option) => option.name || ""}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search for store"
                                />
                            )}
                        />
                        <Box className={classes.root}>
                            {storeData.map((data) =>
                                data.active === true ? (
                                    <>
                                        <Card
                                            sx={{
                                                maxWidth: 384,
                                                maxHeight: 242,
                                            }}
                                            style={{
                                                color: '#fff',
                                                background: `url(${SamsungImage}) lightgray 0px 0px / 100% 158.678% no-repeat`,
                                                borderRadius: '12px',
                                            }}
                                        >
                                            <CardHeader
                                                action={
                                                    <>
                                                        {' '}
                                                        <div
                                                            className=""
                                                            style={{
                                                                display:
                                                                    'inline-flex',
                                                                padding:
                                                                    '4px 12px',
                                                                justifyContent:
                                                                    'center',
                                                                alignItems:
                                                                    'center',
                                                                gap: '6px',
                                                                borderRadius:
                                                                    '8px',
                                                                background:
                                                                    '#FFF',
                                                                color: '#000',
                                                            }}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="17"
                                                                viewBox="0 0 16 17"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M8 1.5C5.23969 1.5 3 3.51594 3 6C3 10 8 15.5 8 15.5C8 15.5 13 10 13 6C13 3.51594 10.7603 1.5 8 1.5ZM8 8.5C7.60444 8.5 7.21776 8.3827 6.88886 8.16294C6.55996 7.94318 6.30362 7.63082 6.15224 7.26537C6.00087 6.89991 5.96126 6.49778 6.03843 6.10982C6.1156 5.72186 6.30608 5.36549 6.58579 5.08579C6.86549 4.80608 7.22186 4.6156 7.60982 4.53843C7.99778 4.46126 8.39991 4.50087 8.76537 4.65224C9.13082 4.80362 9.44318 5.05996 9.66294 5.38886C9.8827 5.71776 10 6.10444 10 6.5C9.99942 7.03026 9.78852 7.53863 9.41357 7.91357C9.03863 8.28852 8.53026 8.49942 8 8.5Z"
                                                                    fill="black"
                                                                    fill-opacity="0.8"
                                                                />
                                                            </svg>
                                                            <div>
                                                                {data.name}
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            />
                                            <div
                                                style={{
                                                    borderRadius: '12px',
                                                    background:
                                                        'linear-gradient(355deg, rgba(0, 0, 0, 0.92) 24.85%, rgba(0, 0, 0, 0.60) 50.53%, rgba(65, 65, 65, 0.31) 74.22%, rgba(255, 255, 255, 0.00) 100%)',
                                                }}
                                            >
                                                <CardContent>
                                                    <Typography>
                                                        {data.name}
                                                    </Typography>
                                                    <span className="shopAdd">
                                                        {data.location}
                                                    </span>
                                                </CardContent>
                                                <CardActions>
                                                    <Button size="small">
                                                        <sapn className="colwhite">
                                                            View Details
                                                        </sapn>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            viewBox="0 0 16 16"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M8.375 3.5L12.875 8L8.375 12.5M12.25 8H3.125"
                                                                stroke="white"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </Button>
                                                </CardActions>
                                            </div>
                                        </Card>
                                    </>
                                ) : (
                                    ''
                                )
                            )}
                        </Box>
                    </StyledContainer>
                </>
            ) : (
                ''
            )}
        </>
    )
}
